import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'

export default class DisruptorController extends AdvancedController {

  static targets = ['content' ];

  static values = {
      isOpen: Boolean
  }

  connect() {
    super.connect();
    // outside click close
    window.addEventListener('click', (e) => {
        if (this.isOpenValue && !this.element.contains(e.target)) {
            this.isOpenValue = false;
            this._handleState();
        }
    })
  }

  onToggleClick(e) {
    e.preventDefault();
    this.isOpenValue = !this.isOpenValue;
    this._handleState();
  }

  _handleState() {
    if (this.isOpenValue) {
        this.element.classList.add('-open')
    } else {
        this.element.classList.remove('-open')
    }
  }

}
